import * as React from 'react';
import '../../constants/domains.js';
import '../../constants/globals.js';
import { SWAN_PUBLIC_ASSET_FOLDER } from '../../constants/paths.js';
import '../../constants/tokens-color.js';
import '../../contexts/screen-class-provider/index.js';
import '../../contexts/swan-provider/swan-provider.component.js';
import { swanLoaderConfigProps } from '../../contexts/swan-provider/swan-provider.context.js';
import { SwanAssetFolders } from '../../types/enums.js';
import '../../utilities/base-url.utils.js';
import '../../utilities/manifest-icons.utils.js';
import '../../utilities/manifest-js.utils.js';
import { getSwanAssetFolderName } from '../../utilities/manifest.utils.js';
import { useSwanHeadConfig } from './head.hook.js';
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
_objectSpread({}, swanLoaderConfigProps);
const SwanPageMeta = _ref => {
  let {
    swanBaseUrl,
    swanPathType,
    swanTenant,
    swanLocale,
    renderWith: Comp = React.Fragment
  } = _ref;
  const {
    swanBaseUrl: baseUrl
  } = useSwanHeadConfig(swanBaseUrl, swanPathType, swanTenant, swanLocale);
  const favFolder = "".concat(baseUrl).concat(SWAN_PUBLIC_ASSET_FOLDER, "/").concat(getSwanAssetFolderName(SwanAssetFolders.FAVICONS));
  return /*#__PURE__*/React.createElement(Comp, null, /*#__PURE__*/React.createElement("meta", {
    key: "charset",
    charSet: "UTF-8"
  }), /*#__PURE__*/React.createElement("meta", {
    key: "meta2",
    httpEquiv: "X-UA-Compatible",
    content: "IE=edge"
  }), /*#__PURE__*/React.createElement("meta", {
    key: "viewport",
    name: "viewport",
    content: "width=device-width, initial-scale=1.0"
  }), /*#__PURE__*/React.createElement("meta", {
    key: "telephone format detection",
    name: "format-detection",
    content: "telephone=no"
  }), /*#__PURE__*/React.createElement("link", {
    key: "favIcon",
    rel: "shortcut icon",
    href: "".concat(favFolder, "/favicon.ico")
  }), /*#__PURE__*/React.createElement("link", {
    key: "favIcon152",
    rel: "apple-touch-icon",
    sizes: "152x152",
    href: "".concat(favFolder, "/apple-icon-152x152.png")
  }), /*#__PURE__*/React.createElement("link", {
    key: "favIcon120",
    rel: "apple-touch-icon",
    sizes: "120x120",
    href: "".concat(favFolder, "/apple-icon-120x120.png")
  }), /*#__PURE__*/React.createElement("link", {
    key: "favIcon76",
    rel: "apple-touch-icon",
    sizes: "76x76",
    href: "".concat(favFolder, "/apple-icon-76x76.png")
  }), /*#__PURE__*/React.createElement("link", {
    key: "favIcon60",
    rel: "apple-touch-icon",
    sizes: "60x60",
    href: "".concat(favFolder, "/apple-icon-60x60.png")
  }));
};
export { SwanPageMeta };